import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import logoImg from "../../Assests/images/ftr_logo.png";

function NavbarV1({ onOpenLogin, onOpenSignup }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", handleScroll);

    try {
      const stored = localStorage.getItem("user");
      if (stored) {
        setCurrentUser(JSON.parse(stored));
      }
    } catch (e) {
      console.error(e);
    }

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("authToken");
    setCurrentUser(null);
    navigate("/");
  };

  return (
    <header className={`v1-header-container ${scrolled ? "v1-header-scrolled" : ""}`}>
      <div className="v1-header-inner">
        {/* Logo */}
        <Link to="/-v1" className="v1-logo-link" aria-label="Weyfarin Experiences">
          <img src={logoImg} alt="Weyfarin Experiences" className="v1-logo-img" />
        </Link>

        {/* Primary Navigation Links */}
        <nav className="v1-header-nav">
          <ul className="v1-nav-links">
            <li>
              <Link to="/experiences" className="v1-nav-link active">
                Experiences
              </Link>
            </li>
            <li>
              <Link to="/experiences" className="v1-nav-link">
                Destinations
              </Link>
            </li>
            <li>
              <Link to="/about" className="v1-nav-link">
                About Us
              </Link>
            </li>
          </ul>
        </nav>

        {/* Actions */}
        <div className="v1-header-actions">
          <Link to="/host-add-profiles" className="v1-btn-become-host">
            Become a Host
          </Link>

          {currentUser ? (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Link
                to="/user-profile"
                className="v1-btn-login"
                style={{ fontWeight: 600, color: "var(--wf-navy-btn)" }}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                {currentUser.name || "My Account"}
              </Link>
              <button
                onClick={handleLogout}
                className="v1-btn-login"
                style={{ fontSize: "12px", color: "#64748B" }}
              >
                Logout
              </button>
            </div>
          ) : (
            <>
              <button
                type="button"
                className="v1-btn-login"
                onClick={onOpenLogin}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                <span>Login</span>
              </button>

              <button
                type="button"
                className="v1-btn-signup"
                onClick={onOpenSignup || onOpenLogin}
              >
                Sign Up
              </button>
            </>
          )}

          {/* Hamburger Menu button */}
          <button
            type="button"
            className="v1-btn-menu"
            aria-label="Toggle menu"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#0F172A"
              strokeWidth="2"
              strokeLinecap="round"
            >
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Drawer Dropdown */}
      {mobileMenuOpen && (
        <div
          style={{
            background: "#FFFFFF",
            borderBottom: "1px solid var(--wf-border-light)",
            padding: "20px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            boxShadow: "0 10px 20px rgba(0,0,0,0.06)",
          }}
        >
          <Link
            to="/experiences"
            className="v1-nav-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            Experiences
          </Link>
          <Link
            to="/experiences"
            className="v1-nav-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            Destinations
          </Link>
          <Link
            to="/about"
            className="v1-nav-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            About Us
          </Link>
          <Link
            to="/blogs"
            className="v1-nav-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            Travel Stories
          </Link>
          <Link
            to="/host-add-profiles"
            className="v1-nav-link"
            style={{ color: "var(--wf-gold)", fontWeight: 700 }}
            onClick={() => setMobileMenuOpen(false)}
          >
            Become a Host
          </Link>
          {!currentUser && (
            <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
              <button
                type="button"
                className="v1-btn-login"
                style={{
                  border: "1px solid var(--wf-border-light)",
                  flex: 1,
                  justifyContent: "center",
                  height: "44px",
                }}
                onClick={() => {
                  setMobileMenuOpen(false);
                  onOpenLogin();
                }}
              >
                Login
              </button>
              <button
                type="button"
                className="v1-btn-signup"
                style={{ flex: 1, height: "44px" }}
                onClick={() => {
                  setMobileMenuOpen(false);
                  onOpenSignup ? onOpenSignup() : onOpenLogin();
                }}
              >
                Sign Up
              </button>
            </div>
          )}
        </div>
      )}
    </header>
  );
}

export default NavbarV1;
